const Announcement = () => {
    return (
        <>
            <div style={{
                height: '40vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                textAlign: 'center'
            }}>
                <h3 style={{ fontSize: '18px', color: '#666' }}>No Announcement available</h3>
            </div>
        </>
    );
};

export default Announcement;